import React, { Component } from 'react';

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import ModalBox from '../Common/Modals/ModalBox';

import { API } from '../../ws/constants';
import { AddEditHolidayReasons } from './AddEditHolidayReasons';
import { AddEditPaymentConditions } from './AddEditPaymentConditions';
import { AddEditSellers } from './AddEditSellers';
import { AddEditJobTypes } from './AddEditJobTypes';

import './style.css';

class Settings extends Component {
    constructor(props) {
        super(props);

        this.state = {
            editable: true
            , vatValue: 0
            , name: ""
            , shortname: ""
            , fullname: ""
            , fetchHolidayReasons: null
            , fetchPaymentConditions: null
            , fetchSellers: null
            , fetchJobTypes: null
            , openModal: false
            , returnTitle: "Erro"
            , returnText: "Ocorreu algum erro"
            , returnType: 1
        };
    }

    componentDidMount() {
        Promise.all([
            fetch(API + "getbasicsettings")
            , fetch(API + "getholidayreasons")
            , fetch(API + "getpaymentconditions")
            , fetch(API + "getsellers")
            , fetch(API + "getjobtypes")
        ])
        .then(responses => Promise.all(responses.map(r => r.json())))
        .then((data) => {
            const webSiteData = data[0].data[0];
            this.setState({
                vatValue: webSiteData?.VatValue
                , name: webSiteData?.Name
                , shortname: webSiteData?.Shortname
                , fullname: webSiteData?.Fullname
                , fetchHolidayReasons: data[1]
                , fetchPaymentConditions: data[2]
                , fetchSellers: data[3]
                , fetchJobTypes: data[4]
            });
        });
    }

    saveSettings = () => {
        const { vatValue, name, shortname, fullname } = this.state;

        this.setState({ loading: true });

        fetch(API + "savebasicsettings", {
            method: 'POST'
            ,headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
            ,body: JSON.stringify({
                vatvalue: vatValue
                , name
                , shortname
                , fullname
                ,cur_userid:this.props.loginData.Id
                ,cur_username:this.props.loginData.Name
            })
        })
        .then(response => response.json())
        .then(result => {
            const modalParams = {
                returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro"
                , returnType: result.shortmsg === "OK" ? 1 : 2
                , returnText: result.message
            }
            this.openModal(modalParams);
            this.props.refreshBasicSettings();
        });
}

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
    }

    openModal = (modalParams) => {
        this.setState({ ...modalParams, openModal: true });
    }

    handleFieldChange = (e) => this.setState({ [e.target.id]: e.target.value });

    render() {
        const { vatValue, name, shortname, fullname, editable } = this.state;
        const { isAdmin, loginData } = this.props;
        const holidayReasons = this.state.fetchHolidayReasons?.data
            , paymentConditions = this.state.fetchPaymentConditions?.data
            , sellers = this.state.fetchSellers?.data
            , jobTypes = this.state.fetchJobTypes?.data;

        return (
            <div id="settingsPage">
                <div>
                    <div className="pageHeader">
                        <h1>
                            <i className="fa fa-cog"></i> Configurações da App
                        </h1>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <div className="fieldHolder required">
                                <TextField fullWidth
                                    id="name"
                                    type="text"
                                    value={name}
                                    onChange={this.handleFieldChange}
                                    label="Nome"
                                    placeholder="Introduza o Nome da app"
                                    disabled={!editable}
                                    data-empty-error-message="Este campo não pode estar vazio" />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="fieldHolder required">
                                <TextField fullWidth
                                    id="shortname"
                                    type="text"
                                    value={shortname}
                                    onChange={this.handleFieldChange}
                                    label="Nome peq."
                                    placeholder="Introduza o nome pequeno da app"
                                    disabled={!editable}
                                    data-empty-error-message="Este campo não pode estar vazio" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-8">
                            <div className="fieldHolder required">
                                <TextField fullWidth
                                    id="fullname"
                                    type="text"
                                    value={fullname}
                                    onChange={this.handleFieldChange}
                                    label="Nome completo"
                                    placeholder="Introduza o nome completo da app"
                                    disabled={!editable}
                                    data-empty-error-message="Este campo não pode estar vazio" />
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="fieldHolder required">
                                <TextField fullWidth
                                    id="vatValue"
                                    type="number"
                                    value={vatValue}
                                    onChange={this.handleFieldChange}
                                    label="% de IVA"
                                    placeholder="Introduza a % de IVA"
                                    disabled={!editable}
                                    data-empty-error-message="Este campo não pode estar vazio" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 buttonsHolder">
                            {editable && <Button onClick={this.saveSettings} className="button float-right" variant="contained" color="primary"><i className='fa fa-check'></i> Salvar</Button>}
                        </div>
                    </div>
                    <div className="pageHeader">
                        <h1>
                            <i className="fa fa-cog"></i> Configurações de Campos
                        </h1>
                    </div>
                    <Accordion>
                        <AccordionSummary>
                            <p className=""><i className="fa fa-plane"></i> Justificações de Falta</p>
                        </AccordionSummary>
                        <AccordionDetails>
                            {holidayReasons && <AddEditHolidayReasons openModal={this.openModal} data={holidayReasons} isAdmin={isAdmin} loginData={loginData} />}
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary>
                            <p className=""><i className="fa fa-credit-card"></i> Condições de Pagamento</p>
                        </AccordionSummary>
                        <AccordionDetails className="container">
                            {paymentConditions && <AddEditPaymentConditions openModal={this.openModal} data={paymentConditions} isAdmin={isAdmin} loginData={loginData} />}
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary>
                            <p className=""><i className="fa fa-user-tie"></i> Tipos de Vendedores</p>
                        </AccordionSummary>
                        <AccordionDetails>
                            {sellers && <AddEditSellers openModal={this.openModal} data={sellers} isAdmin={isAdmin} loginData={loginData} />}
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary>
                            <p className=""><i className="fa fa-users-cog"></i> Cargos de Funcionários</p>
                        </AccordionSummary>
                        <AccordionDetails>
                            {jobTypes && <AddEditJobTypes openModal={this.openModal} data={jobTypes} isAdmin={isAdmin} loginData={loginData} />}
                        </AccordionDetails>
                    </Accordion>

                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </div>
        );
    }
}

export default Settings;
